<div class="main-content ajustes-page cc-pagina cc-det">
  <div class="container-fluid">
    <!--
      El encabezado es un solo renglón de vidrio con los botones: a la izquierda «Regresar» y, a su lado, el nombre del
      proyecto; a la derecha el commit y la versión de este análisis y las salidas (SonarQube, Excel, Reporte PDF). El
      veredicto del gate, sus criterios y la fecha del análisis se ven en SonarQube con su botón y siguen en el PDF y el
      Excel (Norman, 12/10/2026). Si no cabe en un renglón, las salidas bajan juntas al siguiente, a la derecha.
    -->
    <section class="ajustes-hero cc-det__hero">
      <div class="cc-det__acciones">
        <!-- «Regresar» siempre a la vista, también mientras carga: vuelve al tablero como se dejó (cc-regreso.ts). -->
        <a class="app-form-btn app-form-btn--secondary app-form-btn--compact cc-det__regresar" [routerLink]="regreso"
           title="Regresar al tablero con todos los proyectos" aria-label="Regresar al tablero con todos los proyectos">
          <span class="material-icons" aria-hidden="true">arrow_back</span>
          Regresar
        </a>
        <!-- Solo el nombre, para no perder de qué proyecto se trata: sin pastillas ni marcas. -->
        <h1 class="cc-det__nombre">{{ titulo }}</h1>
        <div class="cc-det__derecha" *ngIf="proyecto">
          <!--
            Este análisis, antes de las salidas (así lo recorre el teclado): solo el commit y la versión. Lo técnico (CI,
            versión de SonarQube, foto del COS y eventos) se ve en SonarQube y sigue en el PDF y el Excel (Norman,
            09/10/2026). Sin commit ni versión no hay ficha.
          -->
          <dl class="cc-det__ficha" *ngIf="estado.valor !== 'SIN_ANALISIS' && (commit || versionTexto)" aria-label="Este análisis">
            <div class="cc-det__dato" *ngIf="commit">
              <dt>Commit</dt>
              <dd>
                <a class="cc-enlace cc-mono" *ngIf="proyecto.enlaceCommit; else commitTexto" [href]="proyecto.enlaceCommit"
                   target="_blank" rel="noopener" title="Abrir el commit en Azure DevOps">{{ commit }}</a>
                <ng-template #commitTexto><span class="cc-mono cc-num">{{ commit }}</span></ng-template>
              </dd>
            </div>
            <div class="cc-det__dato" *ngIf="versionTexto">
              <dt>Versión</dt>
              <dd class="cc-num" [attr.title]="versionTexto">{{ versionTexto }}</dd>
            </div>
          </dl>
          <!--
            Las salidas con los iconos de trazo fino del tablero (graficas/icono-cc.component.ts): SonarQube, la hoja del
            Excel y el documento del PDF, el mismo del renglón del tablero. Mientras se emite, el icono del que emite es el
            anillo que gira y su globo dice que primero se consulta SonarQube (el servidor trae lo último antes de
            congelar la foto).
          -->
          <div class="cc-det__salidas">
            <a class="app-form-btn app-form-btn--secondary app-form-btn--compact cc-det__salida" [href]="proyecto.enlaceSonar" target="_blank"
               rel="noopener" title="Abrir el proyecto en SonarQube">
              <app-icono-cc nombre="sonar"></app-icono-cc>
              SonarQube
            </a>
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact cc-det__salida" *ngIf="puedeReportar"
                    [disabled]="emitiendo !== null || estado.valor === 'SIN_ANALISIS'" [attr.aria-busy]="emitiendo === 'EXCEL'"
                    [attr.title]="emitiendo === 'EXCEL' ? emitiendoExcel : null" (click)="excel()">
              <app-icono-cc [nombre]="emitiendo === 'EXCEL' ? 'girando' : 'hoja'"></app-icono-cc>
              {{ emitiendo === "EXCEL" ? "Emitiendo…" : "Excel" }}
            </button>
            <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact cc-det__salida" *ngIf="puedeReportar"
                    [disabled]="emitiendo !== null || estado.valor === 'SIN_ANALISIS'" [attr.aria-busy]="emitiendo === 'PDF'"
                    [attr.title]="emitiendo === 'PDF' ? emitiendoPdf : null" (click)="pdf()">
              <app-icono-cc [nombre]="emitiendo === 'PDF' ? 'girando' : 'pdf'"></app-icono-cc>
              {{ emitiendo === "PDF" ? "Emitiendo…" : "Reporte PDF" }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Lo que dejan las acciones (emitir el PDF o el Excel) y los avisos del análisis van como flotantes arriba a la derecha (flotantes/). -->

    <section class="ajustes-card" *ngIf="loading">
      <div class="ajustes-card__body cc-vacio">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando el proyecto</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <!-- Sin botón propio: «Regresar» del encabezado ya está a la vista y lleva al mismo lugar. -->
    <section class="ajustes-card" *ngIf="!loading && error">
      <div class="ajustes-card__body cc-vacio">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo consultar el proyecto</h3>
        <p>{{ error }}</p>
      </div>
    </section>

    <ng-container *ngIf="!loading && !error && proyecto">
      <section class="ajustes-card" *ngIf="estado.valor === 'SIN_ANALISIS'">
        <div class="ajustes-card__body cc-vacio">
          <span class="material-icons" aria-hidden="true">block</span>
          <h3>Nunca se ha analizado</h3>
          <p>Está dado de alta en SonarQube, pero ningún pipeline lo analiza todavía. En cuanto llegue su primer análisis, aquí
            aparecerán sus criterios y sus cifras.</p>
        </div>
      </section>

      <mat-tab-group class="cc-det__pestanas" *ngIf="estado.valor !== 'SIN_ANALISIS'" animationDuration="0ms"
                     [mat-stretch-tabs]="false" mat-align-tabs="start"
                     [selectedIndex]="pestana" (selectedIndexChange)="cambiaPestana($event)" aria-label="Resumen e historial del proyecto">
        <!-- ============================ Resumen ============================ -->
        <mat-tab label="Resumen">
          <ng-template matTabContent>
            <div class="cc-det__cuerpo cc-det__cuerpo--resumen" #cuerpoResumen [style.min-height.px]="altoResumen" [class.is-compacto]="resumenCompacto">
              <!--
                Como el resumen de SonarQube: dos pestañas en un control segmentado, «Código nuevo» (por omisión) y
                «Código general», solo con su nombre; debajo, qué abarca y los mosaicos con su cifra grande, su meta y su
                base. Cada cifra abre en SonarQube la lista de eso mismo.
              -->
              <section class="cc-det__vista" aria-label="Cifras del análisis">
                <div class="cc-det__solapas" [class.is-general]="vista === 'general'" role="tablist" aria-label="Qué código se resume">
                  <ng-container *ngTemplateOutlet="solapa; context: { $implicit: 'nuevo', nombre: 'Código nuevo' }"></ng-container>
                  <ng-container *ngTemplateOutlet="solapa; context: { $implicit: 'general', nombre: 'Código general' }"></ng-container>
                </div>
                <ng-container *ngTemplateOutlet="hoja; context: { $implicit: mosaicosNuevo, id: 'nuevo', nombre: 'Código nuevo', abarca: abarcaNuevo, conMetas: metasNuevo }"></ng-container>
                <ng-container *ngTemplateOutlet="hoja; context: { $implicit: mosaicosGeneral, id: 'general', nombre: 'Código general', abarca: abarcaGeneral, conMetas: metasGeneral }"></ng-container>
              </section>
            </div>
          </ng-template>
        </mat-tab>

        <!-- ============================ Historial ============================ -->
        <!-- Arriba las tres gráficas y abajo la tabla de análisis guardados. Los globos de las gráficas no se salen de
             data-cc-globos (la pestaña recorta lo que se sale). -->
        <mat-tab label="Historial">
          <ng-template matTabContent>
            <div class="cc-det__cuerpo" data-cc-globos>
              <div class="cc-det__graficas" *ngIf="graficas.length > 0">
                <article class="cc-det__grafica cc-entra" *ngFor="let g of graficas; let i = index; trackBy: trackGrafica"
                         [style.--cc-serie-color]="g.tono" [style.animation-delay.ms]="60 * (i + 1)"
                         [attr.aria-labelledby]="'cc-det-grafica-' + g.clave">
                  <header class="cc-det__grafica-encabezado">
                    <h3 class="cc-det__grafica-nombre" [id]="'cc-det-grafica-' + g.clave" title="Código general: todo el proyecto, lo nuevo y lo anterior">
                      <span class="cc-det__grafica-punto" aria-hidden="true"></span>{{ g.nombre }}
                    </h3>
                    <app-cifra-cc class="cc-det__grafica-valor" [valor]="g.ultimo" [formato]="g.formato"></app-cifra-cc>
                    <p class="cc-det__grafica-explica">{{ g.explica }}</p>
                    <p class="cc-det__grafica-cambio" [ngClass]="g.cambio.clase" [attr.title]="g.cambio.titulo">
                      <span class="material-icons" aria-hidden="true">{{ g.cambio.icono }}</span>
                      <span>{{ g.cambio.texto }}</span>
                    </p>
                  </header>
                  <app-serie-cc [nombre]="g.nombre" [fechas]="series?.fechas" [valores]="g.valores" [formato]="g.formato" [tono]="g.tono"
                                [meta]="g.meta" [sentido]="g.sentido" [menosEsMejor]="g.menosEsMejor" [unidad]="g.unidad"
                                [puntos]="puntosSerie"></app-serie-cc>
                </article>
              </div>

              <section class="table-page cc-det__historial" aria-labelledby="cc-det-historial">
                <div class="table-page__card">
                  <h2 id="cc-det-historial" class="cc-oculto">Análisis guardados</h2>
                  <div class="table-page__empty cc-det__historial-vacio" *ngIf="historialError">
                    <span class="material-icons" aria-hidden="true">sync_problem</span>
                    <h3>No se pudo consultar el historial</h3>
                    <p>{{ historialError }}</p>
                    <div class="cc-vacio__acciones">
                      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="consultarHistorial()">
                        Volver a consultar
                      </button>
                    </div>
                  </div>
                  <div class="table-page__empty cc-det__historial-vacio" *ngIf="!historialError && !historialCargando && historial.length === 0">
                    <span class="material-icons" aria-hidden="true">history</span>
                    <h3>Todavía no hay análisis guardados</h3>
                    <p>El COS guarda una foto de cada análisis al sincronizar; aquí quedan aunque SonarQube los purgue.</p>
                  </div>
                  <div class="table-page__table-wrap" [class.cc-atenuado]="historialCargando" *ngIf="!historialError && historial.length > 0">
                    <table class="table-page__table cc-det__tabla" #tablaHistorial [style.--cc-fila-extra]="historialExtra + 'px'">
                      <caption class="cc-oculto">Análisis guardados del proyecto, del más reciente al más viejo.</caption>
                      <thead>
                        <tr>
                          <th scope="col" class="cc-det__col-fecha">Fecha y hora</th>
                          <th scope="col" class="cc-det__col-gate" title="Si el análisis cumplió las metas de calidad que pide el Quality Gate">Quality Gate</th>
                          <th scope="col" title="El commit de git que se analizó">Commit</th>
                          <th scope="col" title="La versión del proyecto que se analizó">Versión</th>
                          <th scope="col" class="cc-det__col-eventos">Eventos y notas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let h of historial; let i = index; trackBy: trackHistorial" class="cc-entra cc-det__renglon" [ngClass]="h.estado.clase"
                            [style.animation-delay.ms]="i * 25">
                          <td class="cc-num cc-det__fecha" [attr.title]="h.hace">{{ h.fecha }}</td>
                          <td class="cc-det__celda-gate">
                            <div class="cc-det__gate">
                              <span class="cc-insignia" [ngClass]="h.estado.clase" [attr.title]="h.gateTitulo">
                                <span class="material-icons" aria-hidden="true">{{ h.estado.icono }}</span>
                                {{ h.estado.texto }}
                              </span>
                              <span class="cc-det__fallan-rotulo" *ngIf="h.fallan as f">{{ f.rotulo }}:</span>
                            </div>
                            <p class="cc-det__fallan" *ngIf="h.fallan as f">
                              <span class="cc-det__fallan-grupo" *ngFor="let g of f.grupos; let ultimo = last"><span class="cc-det__fallan-nombre">{{ g.nombre }}:</span> {{ g.lista }}<span *ngIf="!ultimo"> · </span></span>
                            </p>
                          </td>
                          <td class="cc-det__commit">
                            <a class="cc-enlace cc-mono" *ngIf="h.enlaceCommit; else commitPlano" [href]="h.enlaceCommit" target="_blank"
                               rel="noopener" [attr.title]="'Abrir el commit ' + h.commitCompleto">{{ h.commit || "—" }}</a>
                            <ng-template #commitPlano>
                              <span class="cc-mono cc-num" [attr.title]="h.commitCompleto ? 'Commit completo: ' + h.commitCompleto : null">{{ h.commit || "—" }}</span>
                            </ng-template>
                          </td>
                          <td class="cc-num cc-det__version">{{ h.version || "—" }}</td>
                          <td>
                            <div class="cc-det__eventos">
                              <span class="cc-marca" *ngIf="h.gateCambio" [ngClass]="h.estado.clase" title="El resultado del Quality Gate cambió en este análisis">
                                <span class="material-icons" aria-hidden="true">swap_vert</span>
                                {{ h.gateCambio }}
                              </span>
                              <span class="cc-marca is-aviso" *ngIf="h.borrado" title="SonarQube ya purgó este análisis; la foto es la que guardó el COS">
                                <span class="material-icons" aria-hidden="true">inventory_2</span>
                                ya no está en SonarQube; lo guardó el COS
                              </span>
                              <span class="cc-marca is-neutro" *ngIf="h.sinCifrasNuevo"
                                    title="Cuando el COS guardó este análisis, SonarQube ya tenía uno más nuevo: las cifras del código nuevo no están completas">
                                sin cifras completas de código nuevo
                              </span>
                              <span class="cc-marca is-neutro" *ngFor="let e of eventosVisibles(h)">{{ e }}</span>
                              <button type="button" class="cc-enlace cc-det__ver-mas" *ngIf="eventosOcultos(h) > 0"
                                      [attr.aria-expanded]="eventosAbiertos.has(h.id)" (click)="alternaEventos(h.id)">
                                {{ eventosAbiertos.has(h.id) ? "Ver menos" : "Ver " + eventosOcultos(h) + " más" }}
                              </button>
                              <span class="cc-det__sin-eventos" *ngIf="!h.gateCambio && !h.borrado && !h.sinCifrasNuevo && h.eventos.length === 0">—</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="table-page__footer" *ngIf="!historialError && historial.length > 0">
                    <div class="table-page__meta cc-sec"><span>{{ rangoHistorial }}</span></div>
                    <div class="table-page__pager" *ngIf="paginasHistorial.length > 1">
                      <button type="button" class="table-page__pager-link" [disabled]="historialPagina === 1 || historialCargando"
                              (click)="irAHistorial(historialPagina - 1)">Anterior</button>
                      <button type="button" class="table-page__pager-page" *ngFor="let n of paginasHistorial" [class.is-current]="n === historialPagina"
                              [attr.aria-current]="n === historialPagina ? 'page' : null" [disabled]="historialCargando" (click)="irAHistorial(n)">{{ n }}</button>
                      <button type="button" class="table-page__pager-link" [disabled]="historialPagina === paginasHistorial.length || historialCargando"
                              (click)="irAHistorial(historialPagina + 1)">Siguiente</button>
                    </div>
                  </div>
                </div>
              </section>

            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
  </div>
</div>

<!--
  Una pestaña del Resumen, como «New Code» y «Overall Code» de SonarQube: solo su nombre. La elegida lleva la pastilla
  del control; las flechas, Inicio y Fin pasan de una a otra.
-->
<ng-template #solapa let-id let-nombre="nombre">
  <button type="button" class="cc-det__solapa" role="tab" [id]="'cc-det-solapa-' + id" [attr.aria-selected]="vista === id"
          [attr.aria-controls]="'cc-det-hoja-' + id" [attr.tabindex]="vista === id ? 0 : -1"
          (click)="eligeVista(id)" (keydown)="teclaVista($event)">{{ nombre }}</button>
</ng-template>

<!--
  Lo que enseña una pestaña: qué abarca y sus mosaicos en hileras (las dos se estiran parejo hasta el final de la
  ventana; el alto que sobra se reparte en el aire de cada mosaico, sin agrandar la letra). En una pestaña sin metas
  del Quality Gate sus cifras no repiten «Sin meta». Su h2 (oculto) lleva el nombre de la pestaña, para que los h3 de
  los mosaicos no se salten un nivel.
-->
<ng-template #hoja let-hileras let-id="id" let-nombre="nombre" let-abarca="abarca" let-conMetas="conMetas">
  <div class="cc-det__hoja" role="tabpanel" [id]="'cc-det-hoja-' + id" [attr.aria-labelledby]="'cc-det-solapa-' + id" tabindex="0"
       [hidden]="vista !== id" [class.is-sin-metas]="!conMetas">
    <h2 class="cc-oculto">{{ nombre }}</h2>
    <p class="cc-det__abarca"><span *ngFor="let t of abarca" [class.cc-num]="t.cifra" [attr.title]="t.titulo || null">{{ t.texto }}</span></p>
    <div class="cc-det__mosaicos">
      <ul class="cc-det__hilera" *ngFor="let hilera of hileras">
        <li class="cc-det__mosaico" *ngFor="let m of hilera; trackBy: trackMosaico" [class.is-falla]="m.falla" [attr.data-mosaico]="m.clave">
          <div class="cc-det__mosaico-cuerpo">
            <h3 class="cc-det__mosaico-nombre">{{ m.nombre }} <span class="cc-det__mosaico-explica">{{ m.explica }}</span></h3>
            <div class="cc-det__mosaico-cifra" *ngIf="m.fila as f">
              <ng-container *ngTemplateOutlet="numero; context: { $implicit: f }"></ng-container>
              <span class="cc-det__sufijo" *ngIf="m.sufijo">{{ m.sufijo }}</span>
              <span class="cc-det__adorno" *ngIf="f.anillo || f.letra">
                <app-anillo-cc class="cc-det__anillo" *ngIf="f.anillo" [valor]="f.anillo.valor" [tono]="f.anillo.tono" [pistaConTono]="f.anillo.pistaConTono"></app-anillo-cc>
                <ng-container *ngIf="f.letra">
                  <span class="cc-cal" [ngClass]="f.letra === '—' ? 'is-nd' : 'is-' + f.letra" [attr.title]="tituloLetra">{{ f.letra }}</span>
                  <span class="cc-det__letra" *ngIf="f.letraTexto">{{ f.letraTexto }}</span>
                </ng-container>
              </span>
            </div>
            <!-- Bajo la cifra, lo que cuenta y su meta; al pie, su base, sus cifras chicas y sus partes: cada pieza en su
                 fila de la hilera, a la misma altura en cada mosaico (en una ventana baja, juntas bajo la cifra). -->
            <div class="cc-det__mosaico-resto" [class.is-sola]="!m.fila">
              <div class="cc-det__mosaico-meta" *ngIf="m.fila as f">
                <p class="cc-det__unidad" *ngIf="m.unidad">{{ m.unidad }}</p>
                <ng-container *ngTemplateOutlet="resultado; context: { $implicit: f, conMetas: conMetas }"></ng-container>
              </div>
              <div class="cc-det__mosaico-base" [class.is-sola]="!m.fila">
                <p class="cc-det__detalle" *ngIf="m.fila?.detalle">{{ m.fila?.detalle }}</p>
                <p class="cc-det__tipos" *ngIf="m.tipos.length > 0">
                  <span class="cc-det__tipo" *ngFor="let t of m.tipos"><a class="cc-enlace cc-num" *ngIf="t.enlace; else tipoSolo" [href]="t.enlace" target="_blank"
                     rel="noopener" [attr.title]="t.titulo">{{ t.cifra }}</a><ng-template #tipoSolo><span class="cc-num cc-det__tipo-cifra">{{ t.cifra }}</span></ng-template> {{ t.texto }}</span>
                </p>
                <ul class="cc-det__partes" *ngIf="m.partes.length > 0" [class.is-tabla]="m.partes.length > 1">
                  <li class="cc-det__parte" *ngFor="let p of m.partes" [class.is-falla]="p.falla">
                    <span class="cc-det__parte-nombre" [attr.title]="p.ayuda || null">{{ p.nombre }}</span>
                    <span class="cc-det__parte-valor">
                      <ng-container *ngIf="p.letra">
                        <span class="cc-cal" [ngClass]="p.letra === '—' ? 'is-nd' : 'is-' + p.letra" [attr.title]="tituloLetra">{{ p.letra }}</span>
                        <span class="cc-det__letra" *ngIf="p.letraTexto">{{ p.letraTexto }}</span>
                      </ng-container>
                      <ng-container *ngIf="!p.letra"><ng-container *ngTemplateOutlet="numero; context: { $implicit: p }"></ng-container></ng-container>
                    </span>
                    <ng-container *ngTemplateOutlet="resultado; context: { $implicit: p, conMetas: conMetas && !p.sinResultado }"></ng-container>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</ng-template>

<!-- Una cifra: con su enlace a la lista de SonarQube si el servidor lo manda; si no, igual pero sin enlace. -->
<ng-template #numero let-f>
  <a class="cc-det__numero is-enlace" *ngIf="f.cifra && f.enlace; else numeroSolo" [href]="f.enlace" target="_blank" rel="noopener"
     [attr.title]="f.enlaceTitulo" [style.min-width.ch]="anchoCifra(f)"><app-cifra-cc [valor]="f.cifra.valor" [formato]="f.cifra.formato"></app-cifra-cc></a>
  <ng-template #numeroSolo>
    <span class="cc-det__numero" [style.min-width.ch]="anchoCifra(f)">
      <app-cifra-cc *ngIf="f.cifra" [valor]="f.cifra.valor" [formato]="f.cifra.formato"></app-cifra-cc>
      <span class="cc-det__valor-texto" *ngIf="f.valor">{{ f.valor }}</span>
    </span>
  </ng-template>
</ng-template>

<!--
  Si cumple la meta del Quality Gate y cuál es («Cumple · Meta: 80 % o más»); abajo, desde cuándo no la cumple o la
  nota (ignorada, la calificación que muestra SonarQube).
-->
<ng-template #resultado let-f let-conMetas="conMetas">
  <p class="cc-det__resultado" [ngClass]="f.resultado.clase" *ngIf="conMetas || f.meta || f.desde || f.nota">
    <span class="cc-det__veredicto" *ngIf="conMetas" [attr.title]="f.resultado.titulo">
      <span class="material-icons" aria-hidden="true">{{ f.resultado.icono }}</span>
      {{ f.resultado.texto }}
    </span>
    <span class="cc-det__pide" *ngIf="f.meta">{{ f.meta }}</span>
    <span class="cc-det__desde" *ngIf="f.desde">{{ f.desde }}</span>
    <span class="cc-det__nota" *ngIf="f.nota" [attr.title]="f.notaTitulo || null">{{ f.nota }}</span>
  </p>
</ng-template>
